<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto h-[100px] w-auto" src="/img/spike-logo.svg" alt="Spike" />
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Password changed</h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <div class="space-y-6 text-gray-700 text-sm">
          <p
            >You new password has been set. Click the button below to go to the sign-in screen and then sign-in with
            your new password.</p
          >
          <div class="w-full flex justify-center">
            <a :href="signInRoute">
              <button
                type="submit"
                class="py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-600 disabled:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-600"
              >
                Go to Sign-In
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ScreenName, ScreenRoute } from "@spike/app2-sitemap/src/auth.js";
import { onMounted, ref } from "vue";
import * as Nav from "../../navigation";
const signInRoute = ref("#" + ScreenRoute.SignIn);
onMounted(async () => {
  // console.log("onMounted:", ScreenRoute.ForgotPasswordComplete);
  Nav.prevScreensComplete(ScreenName.ForgotPasswordComplete);
});
</script>
